import { gql } from "@apollo/client";
import client from "../apolloClient";
import {
  CitiesResponse,
  City,
  CityFilters,
  CityRequest,
  UpdateCityPayload,
} from "../../schemas/citySchema";

const GET_CITIES = gql`
  query GetCities($page: Int, $pageSize: Int, $search: String) {
    cities(page: $page, pageSize: $pageSize, search: $search) {
      cities {
        id
        name
        tenantId
        createdBy
        createdAt
        updatedAt
        regions {
          id
          name
          cityId
          tenantId
          createdBy
          createdAt
          updatedAt
        }
      }
      page
      pageSize
      total
      totalPages
      hasNextPage
      hasPrevPage
    }
  }
`;

const GET_CITY_BY_ID = gql`
  query GetCityById($id: ID!) {
    city(id: $id) {
      id
      name
      tenantId
      createdBy
      createdAt
      updatedAt
      regions {
        id
        name
        cityId
        tenantId
        createdBy
        createdAt
        updatedAt
      }
    }
  }
`;

const CREATE_CITY = gql`
  mutation CreateCity($input: CreateCityInput!) {
    createCity(input: $input)
  }
`;

const UPDATE_CITY = gql`
  mutation UpdateCity($id: ID!, $input: UpdateCityInput!) {
    updateCity(id: $id, input: $input)
  }
`;

const DELETE_CITIES = gql`
  mutation DeleteCities($ids: [ID!]!) {
    deleteCities(ids: $ids)
  }
`;

export const cityService = {
  getAll: async (filters: CityFilters = {}): Promise<CitiesResponse> => {
    const { data } = await client.query({
      query: GET_CITIES,
      variables: filters,
      fetchPolicy: "network-only",
    });
    return data.cities;
  },

  getById: async (id: string): Promise<City> => {
    const { data } = await client.query({
      query: GET_CITY_BY_ID,
      variables: { id },
      fetchPolicy: "network-only",
    });
    return data.city;
  },

  create: async (input: CityRequest): Promise<boolean> => {
    const { data } = await client.mutate({
      mutation: CREATE_CITY,
      variables: { input },
    });
    return data.createCity;
  },

  update: async (payload: UpdateCityPayload): Promise<boolean> => {
    const { data } = await client.mutate({
      mutation: UPDATE_CITY,
      variables: {
        id: payload.id,
        input: payload.city,
      },
    });
    return data.updateCity;
  },

  remove: async (ids: string[]): Promise<boolean> => {
    const { data } = await client.mutate({
      mutation: DELETE_CITIES,
      variables: { ids },
    });
    return data.deleteCities;
  },
};
